import api from "./api";

export const getUsers = () => api.get("/admin/users");

export const createStaff = (data) =>
  api.post("/admin/users", data);

export const updateUser = (id, data) =>
  api.put(`/admin/users/${id}`, data);

export const deleteUser = (id) =>
  api.delete(`/admin/users/${id}`);

export const toggleApproval = (id) =>
  api.put(`/admin/users/${id}/toggle`);
